import React from "react";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";

import FormikDateInput from "components/InputsField/formikInputs/FormikDateField";
import Title from "components/common/Layout/Title";
import FormikTextField from "components/InputsField/formikInputs/FormikTextField";
import FormikCheckboxField from "components/InputsField/formikInputs/FormikCheckboxField";
import { timeInputHHMM } from "components/InputsField/inputFormats";
import { ERROR_PLACE } from "components/InputsField/InputError";
import FormRow, { ALIGN } from "components/common/Layout/FormRow";
import Label from "components/InputsField/Label";

import styles from "./styles.module.scss";

export default function FreightsDate() {
    const { values } = useFormikContext();
    const { t } = useTranslation();

    const getTranslate = (str) => {
        return t("cargoFields.date_time_section." + str);
    };

  return (
        <>
            <Title withMargin>{getTranslate("heading")}</Title>
            <FormRow>
                <FormRow withSpace>
                    <FormikDateInput
                        name="loading_date_from"
                        label={getTranslate("date_uploading")}
                        minDate={new Date(new Date().setHours(0, 0, 0, 0))}
                        maxDate={values.loading_date_to && new Date(values.loading_date_to)}
                        errorMode={ERROR_PLACE.topRight}
                        isRequired
                    />
                    <FormikDateInput
                        name="loading_date_to"
                        minDate={
                            values.loading_date_from
                                ? new Date(values.loading_date_from)
                                : new Date(new Date().setHours(0, 0, 0, 0))
                        }
                        maxDate={values.unloading_date_from && new Date(values.unloading_date_from)}
                        errorMode={ERROR_PLACE.topRight}
                        label=" "
                    />
                </FormRow>
                <FormRow>
                    <div>
                        <Label label={getTranslate("time_uploading")} className={styles.label} />
                        <FormRow withSpace align={ALIGN.end}>
                            {values.round_clock1 ? (
                                <FormRow>
                                    <div className={styles.space} />
                                </FormRow>
                            ) : (
                                <FormRow withSpace withLine fromTo>
                                    <FormikTextField
                                        name="loading_time_from"
                                        placeholder="00:00"
                                        format={timeInputHHMM}
                                        errorMode={ERROR_PLACE.bottomLeft}
                                    />
                                    <FormikTextField
                                        name="loading_time_to"
                                        placeholder="00:00"
                                        format={timeInputHHMM}
                                        errorMode={ERROR_PLACE.bottomLeft}
                                    />
                                </FormRow>
                            )}
                            <div className={styles.checkbox}>
                                <FormikCheckboxField
                                    label={getTranslate("24_box")}
                                    name="round_clock1"
                                    id="round_clock1"
                                />
                            </div>
                        </FormRow>
                    </div>
                </FormRow>
            </FormRow>

            <FormRow withMargin>
                <FormRow withSpace>
                    <FormikDateInput
                        name="unloading_date_from"
                        label={getTranslate("date_unloading")}
                        isRequired={true}
                        minDate={
                            values.loading_date_to
                                ? new Date(values.loading_date_to)
                                : values.loading_date_from
                                ? new Date(values.loading_date_from)
                                : new Date(Date.now())
                        }
                        maxDate={values.unloading_date_to && new Date(values.unloading_date_to)}
                        errorMode={ERROR_PLACE.topRight}
                    />
                    <FormikDateInput
                        name="unloading_date_to"
                        minDate={
                            values.unloading_date_from
                                ? new Date(values.unloading_date_from)
                                : values.loading_date_to
                                ? new Date(values.loading_date_to)
                                : values.loading_date_from
                                ? new Date(values.loading_date_from)
                                : new Date(Date.now())
                        }
                        errorMode={ERROR_PLACE.topRight}
                        label=" "
                    />
                </FormRow>
                <FormRow>
                    <div>
                        <Label label={getTranslate("time_unloading")} className={styles.label} />
                        <FormRow withSpace align={ALIGN.end}>
                            {values.round_clock2 ? (
                                <FormRow>
                                    <div className={styles.space} />
                                </FormRow>
                            ) : (
                                <FormRow withSpace withLine fromTo>
                                    <FormikTextField
                                        name="unloading_time_from"
                                        placeholder="00:00"
                                        format={timeInputHHMM}
                                        errorMode={ERROR_PLACE.bottomLeft}
                                    />
                                    <FormikTextField
                                        name="unloading_time_to"
                                        placeholder="00:00"
                                        format={timeInputHHMM}
                                        errorMode={ERROR_PLACE.bottomLeft}
                                    />
                                </FormRow>
                            )}
                            <div className={styles.checkbox}>
                                <FormikCheckboxField
                                    label={getTranslate("24_box")}
                                    name="round_clock2"
                                    id="round_clock2"
                                />
                            </div>
                        </FormRow>
                    </div>
                </FormRow>
            </FormRow>
        </>
    );
}
